export default __webpack_public_path__ + "static/media/grid3.57ceb0e1.png";